export const PLC_ROUTE = {
  name: 'plc/:plcid',
  route(plcId: string): string[] {
    return ['/', this.name];
  },
  DEFAULT: 'plcs',
  REFLECTIONS: {
    name: 'reflections',
    route(plcId: string): string[] {
      return [...PLC_ROUTE.route(plcId), this.name];
    },
  },
  REPORTS: {
    name: 'results',
    route(plcId: string): string[] {
      return [...PLC_ROUTE.route(plcId), this.name];
    },
  },
  RESOURCES: {
    name: 'resources',
    route(plcId: string): string[] {
      return [...PLC_ROUTE.route(plcId), this.name];
    },
    EDIT: {
      name: 'edit',
      route(plcId: string): string[] {
        return [...PLC_ROUTE.RESOURCES.route(plcId), this.name];
      }
    }
  },
  RESULTS: {
    name: 'results',
    route(plcId: string): string[] {
      return [...PLC_ROUTE.route(plcId), this.name];
    },
  }
}
